import { useLazyFetchCustomersQuery } from '@api/Trinium/Endpoints/Customer/slice';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import useDebouncer from '@hooks/useDebounce';
import { useMemo, useState } from 'react';
import LookupList from './LookupList';
import { LookupProps, minimumSearchLength } from './types';

export default function CustomerLookup(props: LookupProps) {
  const { number: terminalNumber } = useCurrentTerminal();
  const [fetchCustomers, { data, isFetching }] = useLazyFetchCustomersQuery();
  const [search, setSearch] = useState('');

  useDebouncer(
    () => {
      // Only active customers, matching what the Research form's customer field offers
      if (search.length >= minimumSearchLength) void fetchCustomers({ terminalNumber, startsWith: search, isActive: true });
    },
    [search, terminalNumber],
    500
  );

  const items = useMemo(() => (data ?? []).map((customer) => ({ id: customer.id, name: customer.name, detail: customer.city })), [data]);

  return (
    <LookupList
      {...props}
      items={items}
      isLoading={isFetching}
      onSearch={setSearch}
    />
  );
}
